import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

interface IChangePasswordForm {
    newPassword: string,
    confirmPassword: string
}

export class ChangePasswordValidator implements IValidator {
    constructor(form: IChangePasswordForm) {
        this._form = form;
        this._validators = this.getValidators();
    }

    private _form: IChangePasswordForm;

    private _validators: IPropertyValidator[];
    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "newPassword",
                message: () => this.validateNewPasswordMessage(),
                validator: () => this.validateNewPassword()
            },
            {
                key: "confirmPassword",
                message: () => this.validateConfirmPasswordMessage(),
                validator: () => this.validateConfirmPassword()
            }
        ];
    }

    private validateNewPasswordMessage(): string {
        if (!this._form.newPassword || this._form.newPassword.trim().length < 6) {
            return "New Password must be at least 6 characters long.";
        }
        return "";
    }

    private validateNewPassword(): boolean {
        let isValid = false;
        if (this._form.newPassword && this._form.newPassword.trim().length >= 6) {
            isValid = true;
        }

        return isValid;
    }


    private validateConfirmPasswordMessage(): string {
        if (this._form.newPassword.trim().length > 0 && this._form.confirmPassword.trim().length > 0 && this._form.newPassword.localeCompare(this._form.confirmPassword) != 0) {
            return "New Password and Confirm Password do not match.";
        }
        return "";
    }

    private validateConfirmPassword(): boolean {
        let isValid = false;
        if (this._form.newPassword.trim().length > 0 && this._form.confirmPassword.trim().length > 0 && this._form.newPassword.localeCompare(this._form.confirmPassword) == 0) {
            isValid = true;
        }

        return isValid;
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    reset() {
        this.errors = {};
    }

    errors: { [key: string]: string } = {};
}